import React, { useState } from 'react';
import { MailIcon } from 'lucide-react';
interface AuthScreenProps {
  onLogin: () => void;
}
export function AuthScreen({
  onLogin
}: AuthScreenProps) {
  const [email, setEmail] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, we would validate and authenticate here
    onLogin();
  };
  const handleMicrosoftLogin = () => {
    // In a real app, we would authenticate with Microsoft here
    onLogin();
  };
  return <div className="min-h-screen flex bg-indigo-950" data-id="element-1934">
      {/* Left side - Logo and features */}
      <div className="hidden md:flex md:w-1/2 flex-col p-12 justify-center" data-id="element-1935">
        <div className="mb-16" data-id="element-1936">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qycmKCQkapX8vateX2oTZg/Rapid_P2P_-_White-Green.svg" alt="RapidP2P Logo" className="h-12" data-id="element-1937" />
        </div>
        <div className="mb-8" data-id="element-1938">
          <h2 className="text-2xl font-bold text-white mb-3" data-id="element-1939">
            Streamline Your Procurement Process
          </h2>
          <p className="text-indigo-200" data-id="element-1940">
            RapidP2P helps businesses optimize their procurement workflow,
            reduce costs, and improve supplier relationships.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-4 mt-8" data-id="element-1941">
          <div className="bg-indigo-900/50 p-4 rounded-lg" data-id="element-1942">
            <h3 className="font-semibold text-white mb-2" data-id="element-1943">
              Automated Workflows
            </h3>
            <p className="text-sm text-indigo-200" data-id="element-1944">
              Streamline approvals and reduce manual tasks
            </p>
          </div>
          <div className="bg-indigo-900/50 p-4 rounded-lg" data-id="element-1945">
            <h3 className="font-semibold text-white mb-2" data-id="element-1946">Vendor Management</h3>
            <p className="text-sm text-indigo-200" data-id="element-1947">
              Centralize and optimize supplier relationships
            </p>
          </div>
          <div className="bg-indigo-900/50 p-4 rounded-lg" data-id="element-1948">
            <h3 className="font-semibold text-white mb-2" data-id="element-1949">Smart Analytics</h3>
            <p className="text-sm text-indigo-200" data-id="element-1950">
              Gain insights to make better purchasing decisions
            </p>
          </div>
          <div className="bg-indigo-900/50 p-4 rounded-lg" data-id="element-1951">
            <h3 className="font-semibold text-white mb-2" data-id="element-1952">Compliance</h3>
            <p className="text-sm text-indigo-200" data-id="element-1953">
              Ensure regulatory and policy compliance
            </p>
          </div>
        </div>
      </div>
      {/* Right side - Login form */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-8" data-id="element-1954">
        <div className="max-w-md w-full" data-id="element-1955">
          <div className="md:hidden mb-8" data-id="element-1956">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qycmKCQkapX8vateX2oTZg/Rapid_P2P_-_White-Green.svg" alt="RapidP2P Logo" className="h-10" data-id="element-1957" />
          </div>
          <h2 className="text-3xl font-bold text-white mb-8" data-id="element-1958">Login</h2>
          <form onSubmit={handleSubmit} data-id="element-1959">
            <div className="mb-6" data-id="element-1960">
              <label htmlFor="email" className="block text-sm font-medium text-white mb-2" data-id="element-1961">
                Email
              </label>
              <div className="relative" data-id="element-1962">
                <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="pl-10 block w-full rounded-md border-0 bg-indigo-900/50 text-white shadow-sm ring-1 ring-inset ring-indigo-800 placeholder:text-indigo-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 py-2.5" placeholder="Enter your email" required data-id="element-1963" />
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1964">
                  <MailIcon className="h-5 w-5 text-indigo-400" data-id="element-1965" />
                </div>
              </div>
            </div>
            <button type="submit" className="w-full bg-green-500 hover:bg-green-600 text-white font-medium py-2.5 px-4 rounded-md transition-colors mb-4" data-id="element-1966">
              Next
            </button>
          </form>
          <div className="text-center text-sm text-indigo-300 mb-6" data-id="element-1967">
            or continue with
          </div>
          <button onClick={handleMicrosoftLogin} className="w-full flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-4 rounded-md transition-colors mb-8" data-id="element-1968">
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1969">
              <path d="M11.4 2H2V11.4H11.4V2Z" fill="#F25022" data-id="element-1970" />
              <path d="M11.4 12.6H2V22H11.4V12.6Z" fill="#00A4EF" data-id="element-1971" />
              <path d="M22 2H12.6V11.4H22V2Z" fill="#7FBA00" data-id="element-1972" />
              <path d="M22 12.6H12.6V22H22V12.6Z" fill="#FFB900" data-id="element-1973" />
            </svg>
            Sign in with Microsoft
          </button>
          <div className="text-center text-xs text-indigo-300" data-id="element-1974">
            By using RapidP2P, I agree to the{' '}
            <a href="#" className="text-indigo-400 hover:text-indigo-300" data-id="element-1975">
              Privacy Policy
            </a>{' '}
            and{' '}
            <a href="#" className="text-indigo-400 hover:text-indigo-300" data-id="element-1976">
              Terms of Service
            </a>
            .
          </div>
        </div>
      </div>
    </div>;
}